import React from 'react'
import { useNavigate } from "react-router-dom";
import logo from "../../logo-no-background.png"
export default function About() {
  let navigate = useNavigate();
  return (
    <div className="wrapper position-relative">
      <div className="header">
      <a className="logo" href={void(0)} onClick={() => navigate("/")}>
        {/* <img src={logo} alt="" /> */}
        Adaptive Chinese Placement Test
      </a>
      <div className="right-content">
        <a href="#" onClick={() => navigate("/about")}>About</a>       
        <a href={void(0)} onClick={() => navigate("/")}>Home</a>
      </div>
    </div>
      <div className="container">
        <div className="multisteps_form position-relative overflow-hidden" id="wizard">
          <div className='about'>
            <p>Please direct any questions to Feng Xiao (<a href='mailto:feng.xiao@pomona.edu'>feng.xiao@pomona.edu</a>)</p>
            <p>Developed by <strong>Jonathan Becker</strong>, maintained by <strong>Asya Vaisberg</strong>, special thanks to <strong>Jonathan Coveney</strong> for algorithm design</p>
            <p>Thank you to <strong>Jun Lang</strong>, <strong>Kun Nie</strong> & <strong>Zoe Shao</strong> for their contributions to the test items</p>
          </div>
        </div> 
      </div> 
    </div>
  )
}
